import { Box, Button, Checkbox, Stack, Typography } from '@mui/material'
import { inject, observer } from 'mobx-react'
import React from 'react'
import DataUnit from '../../../../../components/customElements/DataUnit/DataUnit'
import CustomAccordion from '../../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import { isOperator } from '../../../../../services/AccountService'
import FormSelect from '../../../../SingleRequestPage/components/SingleRequestDrawer/elements/FormSelect'
import { useChangeEquipmentData } from './hooks/useChangeEquipmentData'

type PropsType = {
  equipmentId: any
  serviceOrderId: any
  serviceStore: any
  preventEdit: any
}

const ReasonDescriptionAccordion = ({
  serviceOrderId,
  serviceStore,
  preventEdit,
}: PropsType) => {
  const { currentServiceData } = serviceStore
  const {
    checkKeyDown,
    control,
    handleEdit,
    handleSubmit,
    isEdit,
    isSaveBtnDisabled,
    onReject,
    onSubmit,
    values,
    incedentTypes,
  } = useChangeEquipmentData(serviceStore, serviceOrderId)

  return (
    //@ts-ignore
    <CustomAccordion
      summary={'Описание неисправности'}
      defaultOpenState={true}
      preventHandleOpen={false}
      onEdit={
        preventEdit || currentServiceData?.status !== 5 ? null : handleEdit
      }
    >
      <Stack
        sx={{ marginTop: '14px', paddingLeft: '12px' }}
        spacing={isEdit ? '14px' : '10px'}
        component={'form'}
        onSubmit={handleSubmit(onSubmit)}
        onKeyDown={checkKeyDown}
      >
        {!isEdit && (
          <>
            <DataUnit
              name='Тип инцидента'
              value={
                currentServiceData.incidentType ?? values.incidentType?.value
              }
              icon={null}
            />
            <DataUnit
              name='Со слов абонента'
              value={currentServiceData.malfunctionType ?? '-'}
              icon={null}
            />
          </>
        )}
        {isEdit && (
          <Box>
            <FormSelect
              control={control}
              fullWidth
              name='incidentType'
              label={'Тип инцидента'}
              placeholder=''
              items={incedentTypes ?? []}
              withLabel
            />
          </Box>
        )}
        {isOperator() && (
          <Box
            className={'fx-nowrap aln-center'}
            sx={{
              cursor: 'default',
              height: '100%',
            }}
          >
            <Checkbox
              sx={{ padding: '0 8px 0 0', cursor: 'default' }}
              checked={currentServiceData.isUrgent}
              onClick={(e) => e.preventDefault()}
            />
            <img
              src={getImageSrc('fire')}
              style={{ width: '18px', marginRight: '4px' }}
            />
            <Typography
              variant={'body1'}
              sx={{
                whiteSpace: 'nowrap',
                fontWeight: '400',
              }}
            >
              Срочная заявка
            </Typography>
          </Box>
        )}
        {isEdit && (
          <Box className={'jst-sa'} sx={{ gap: '8px' }}>
            <Button
              type='submit'
              color={'primary'}
              variant={'contained'}
              fullWidth
              disabled={isSaveBtnDisabled}
            >
              Применить изменения
            </Button>
            <Button
              onClick={onReject}
              color={'primary'}
              variant={'contained'}
              fullWidth
            >
              Отмена
            </Button>
          </Box>
        )}
      </Stack>
    </CustomAccordion>
  )
}

export default inject('serviceStore')(observer(ReasonDescriptionAccordion))
